import React from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CustomBtn from "../ButtonTemplate";

interface AcceptReqBtnProps {
  action: () => void;
  tip?: string;
}

function AcceptReqBtn({ action, tip }: AcceptReqBtnProps) {
  return (
    <CustomBtn
      action={() => {
        action();
      }}
      type="success"
      icon={<AddCircleIcon />}
      tip={tip}
    />
  );
}

export default AcceptReqBtn;
